module.exports = __webpack_public_path__ + "static/media/9-Martinez.01b75aed.png";